
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";

/**
 * ApModuleControlService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ApModuleControlService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetSettings(): Promise<{ [key: string]: any }> {
        return this.$apiService.sendAuth("IApModuleControlService/GetSettings");
    }
}
